<div class="container p-0">
  <!-- Header -->
  <header class="header">
    <div class="toolbar">
      <div class="brand">{{ brandName }}</div>
      <div class="top-icons">
        <button class="icon-button" *ngIf="accType == 1" (click)="openEnquiryModal()">
          <i class="fa fa-plus"></i>
        </button>
        <button class="icon-button" (click)="toggleStatusBar()">
          <i class="fa fa-filter"></i>
        </button>
        <button class="icon-button" (click)="toggleSearchBar()">
          <i class="fa fa-search"></i>
        </button>
        <div class="dropdown">
          <button class="icon-button" (click)="toggleDropdown()">
            <i class="fa fa-ellipsis-vertical"></i>
          </button>
          <div class="dropdown-menu" *ngIf="isDropdownOpen">
            <button class="dropdown-item" (click)="viewProfile()">
              <i class="fa fa-user"></i>
              Profile
            </button>
            <button class="dropdown-item" *ngIf="accType == 1" (click)="goTo('new-enquiry-bulk', '')">
              <i class="fa fa-file"></i>
              Bulk Enquiry
            </button>
            <button class="dropdown-item" (click)="confirmSignout()">
              <i class="fa fa-sign-out"></i>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Search Bar -->
    <div class="search-bar" *ngIf="isSearchBarVisible">
      <div class="search-input-wrapper">
        <input
          type="search"
          [(ngModel)]="searchTerm"
          (input)="onSearchInput($event)"
          placeholder="Search Vehicle"
          class="search-input"
        />
      </div>
    </div>

    <!-- Status Filter -->
    <div class="status-bar" *ngIf="isStatusBarVisible">
      <div class="status-badges">
        <span
          *ngFor="let status of statuses"
          class="status-badge"
          [class.active]="selectedStatuses.includes(status.id)"
          (click)="onStatusToggle(status)"
        >
          {{ status.name }}
        </span>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs">
      <button
        class="tab-button"
        [class.active]="segmentValue === '1'"
        (click)="onSegmentChange('1')"
      >
        Enquiries
      </button>
      <button
        class="tab-button"
        [class.active]="segmentValue === '2'"
        (click)="onSegmentChange('2')"
      >
        Billed
      </button>
    </div>
  </header>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Pull to Refresh Indicator -->
    <div class="refresh-indicator" *ngIf="isRefreshing">
      <div class="spinner"></div>
      <span>Refreshing...</span>
    </div>

    <div class="enquiry-list-container" #listContainer>
      <!-- Enquiries Tab -->
      <ng-container *ngIf="segmentValue === '1'">
        <!-- Loading Skeleton -->
        <ng-container *ngIf="!enquiriesLoaded">
          <div class="card skeleton" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
            <div class="card-content">
              <div class="avatar skeleton-avatar">
                <div class="skeleton-circle"></div>
              </div>
              <div class="details">
                <div class="primary">
                  <div class="skeleton-line vehicle-number"></div>
                  <div class="skeleton-circle status-icon"></div>
                </div>
                <div class="secondary">
                  <div class="skeleton-line location"></div>
                  <div class="skeleton-line status"></div>
                </div>
              </div>
              <div class="meta">
                <div class="skeleton-line date"></div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Actual Enquiries List -->
        <ng-container *ngIf="enquiriesLoaded">
          <ng-container *ngIf="enquiries.length > 0; else emptyState">
            <div
              class="card"
              *ngFor="let enq of enquiries; trackBy: trackEnquiry"
              (click)="openEnqDetails(enq)"
            >
              <div class="card-content">
                <div class="avatar">
                  <img src="assets/avatar.png" alt="Profile" />
                </div>
                <div class="details">
                  <div class="primary">
                    <span class="vehicle-number">
                      <ng-container *ngIf="accType == 1; else seller">
                        {{ enq.veh_no === null || enq.veh_no === undefined || enq.veh_no === '' ? 'NR - ' + (enq.enquiryId ? enq.enquiryId : enq.enquiryNotesId ) : enq.veh_no }}
                        
                      </ng-container>
                      <ng-template #seller>
                        {{ enq.buyerCode + ' - ' + enq.enquiryId }}
                      </ng-template>
                    </span>
                    <span
                      class="status-icon"
                      [style.background-color]="
                        getBackgroundColor(
                          enq.statusDescription,
                          enq.notificationCount
                        )
                      "
                    >
                      <i
                        [class]="
                          'fa ' + statusBasedIconList[enq.statusDescription]
                        "
                      ></i>
                    </span>
                  </div>
                  <div class="secondary">
                    <div class="marquee-line" *ngIf="accType == 2; else buyerLocationOnly">
                      <span class="marquee-content">
                        {{ enq.buyerName || 'Buyer' }}
                        <span class="marquee-sep">•</span>
                        {{ enq.branchName }}
                      </span>
                    </div>
                    <ng-template #buyerLocationOnly>
                      <span class="location">{{ enq.branchName }}</span>
                    </ng-template>
                    <span
                      class="status"
                      [style.color]="
                        getBackgroundColor(
                          enq.statusDescription,
                          enq.notificationCount
                        )
                      "
                    >
                      {{ enq.statusDescription }}
                    </span>
                  </div>
                </div>
                <div class="meta">
                  <span
                    class="date"
                    [class.highlight]="enq.notificationCount !== 0"
                  >
                    {{ enq.enqOn }}
                  </span>
                  <span
                    class="notification-badge"
                    *ngIf="enq.notificationCount !== 0"
                  >
                    {{ enq.notificationCount }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyState>
            <ng-container *ngIf="accType == 1; else accType2Empty">
              <app-empty-screen
                icon="fa-inbox"
                message="No Enquiries Found"
                subMessage="Start by creating your first enquiry"
                [showAction]="true"
                actionLabel="Create Enquiry"
                (onActionClick)="handleCreateEnquiry()"
              >
              </app-empty-screen>
            </ng-container>
            <ng-template #accType2Empty>
              <app-empty-screen
                icon="fa-inbox"
                message="No Enquiries Found"
                subMessage="Stay tuned for new enquiries"
                [showAction]="false"
              >
              </app-empty-screen>
            </ng-template>
          </ng-template>
        </ng-container>

        <!-- Loading spinner -->
        <div class="loading-spinner" *ngIf="isLoading">
          <div class="spinner"></div>
          <p>Loading more items...</p>
        </div>
        <div #infiniteAnchor class="infinite-scroll-anchor" style="height: 1px;"></div>
      </ng-container>

      <!-- Bills Tab -->
      <ng-container *ngIf="segmentValue === '2'">
        <!-- Loading Skeleton -->
        <ng-container *ngIf="!enquiriesLoaded">
          <div class="card skeleton" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
            <div class="card-content">
              <div class="avatar skeleton-avatar">
                <div class="skeleton-circle"></div>
              </div>
              <div class="details">
                <div class="primary">
                  <div class="skeleton-line vehicle-number"></div>
                  <div class="skeleton-circle status-icon"></div>
                </div>
                <div class="secondary">
                  <div class="skeleton-line location"></div>
                  <div class="skeleton-line status"></div>
                </div>
              </div>
              <div class="meta">
                <div class="skeleton-line date"></div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Actual Bills List -->
        <ng-container *ngIf="enquiriesLoaded">
          <ng-container *ngIf="bills.length > 0; else emptyState">
            <div
              class="card"
              *ngFor="let bill of bills; trackBy: trackBill"
              (click)="openEnqDetails(bill)"
            >
              <div class="card-content">
                <div class="avatar">
                  <img src="assets/avatar.png" alt="Profile" />
                </div>
                <div class="details">
                  <div class="primary">
                    <span class="vehicle-number">
                     <ng-container *ngIf="accType == 1; else seller">
                        {{ bill.veh_no === null || bill.veh_no === undefined || bill.veh_no === '' ? 'NR - ' + bill.enquiryId : bill.veh_no }}
                      </ng-container>
                      <ng-template #seller>
                        {{ bill.buyerCode + ' - ' + bill.enquiryId }}
                      </ng-template>
                    </span>
                    <span
                      class="status-icon"
                      [style.background-color]="
                        getBackgroundColor(
                          bill.statusDescription,
                          bill.notificationCount
                        )
                      "
                    >
                      <i
                        [class]="
                          'fa ' + statusBasedIconList[bill.statusDescription]
                        "
                      ></i>
                    </span>
                  </div>
                  <div class="secondary">
                    <div class="marquee-line" *ngIf="accType == 2; else billLocationOnly">
                      <span class="marquee-content">
                        {{ bill.buyerName || 'Buyer' }}
                        <span class="marquee-sep">•</span>
                        {{ bill.branchName }}
                      </span>
                    </div>
                    <ng-template #billLocationOnly>
                      <span class="location">{{ bill.branchName }}</span>
                    </ng-template>
                    <span
                      class="status"
                      [style.color]="
                        getBackgroundColor(
                          bill.statusDescription,
                          bill.notificationCount
                        )
                      "
                    >
                      {{ bill.statusDescription }}
                    </span>
                  </div>
                </div>
                <div class="meta">
                  <span
                    class="date"
                    [class.highlight]="bill.notificationCount !== 0"
                  >
                    {{ bill.enqOn }}
                  </span>
                  <span
                    class="notification-badge"
                    *ngIf="bill.notificationCount !== 0"
                  >
                    {{ bill.notificationCount }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #emptyState>
            <ng-container *ngIf="accType == 1; else accType2Empty">
              <app-empty-screen
                icon="fa-inbox"
                message="No Bills Found"
                subMessage="Start by creating your first enquiry"
                [showAction]="true"
                actionLabel="Create Enquiry"
                (onActionClick)="handleCreateEnquiry()"
              >
              </app-empty-screen>
            </ng-container>
            <ng-template #accType2Empty>
              <app-empty-screen
                icon="fa-inbox"
                message="No Bills Found"
                subMessage="Stay tuned for new enquiries"
                [showAction]="false"
              >
              </app-empty-screen>
            </ng-template>
          </ng-template>
        </ng-container>

        <!-- Loading spinner -->
        <div class="loading-spinner" *ngIf="isLoading">
          <div class="spinner"></div>
          <p>Loading more items...</p>
        </div>
        <div #infiniteAnchor class="infinite-scroll-anchor" style="height: 1px;"></div>
      </ng-container>

    </div>
  </main>
</div>

<!-- Enquiry Type Selection Modal -->
<div class="modal fade show d-block" *ngIf="showEnquiryTypeModal" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="modal-title mb-0">Select Enquiry Type</h5>
        <button type="button" class="btn-close" (click)="closeEnquiryModal()"></button>
      </div>
      <div class="modal-body p-4 text-center">
        <div class="row g-3">
           <div class="col-6">
            <button class="btn btn-outline-success w-100 py-4 d-flex flex-column align-items-center" (click)="goTo('new-enquiry', '1'); closeEnquiryModal()">
              <i class="fas fa-file-alt fa-2x mb-2"></i>
              <span>With Registration No</span>
              <!-- <span>Manual Enquiry</span> -->
              <!-- <small class="text-muted mt-2" style="font-size: 0.75rem;">Minimum response<br>time 30mins</small> -->
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-outline-primary w-100 py-4 d-flex flex-column align-items-center" (click)="goTo('new-enquiry', '2'); closeEnquiryModal()">
              <i class="fas fa-bolt fa-2x mb-2"></i>
              <span>Without Registration No</span>
              <!-- <span>Automatic Enquiry</span> -->
              <!-- <small class="text-muted mt-2" style="font-size: 0.75rem;">Immediate response<br>within 1 min</small> -->
            </button>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Behalf Notes Selection Modal -->
<div class="modal fade show d-block" *ngIf="showBehalfModal" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="modal-title mb-0">Select Behalf Enquiry Note</h5>
        <button type="button" class="btn-close" (click)="closeBehalfModal()"></button>
      </div>
      <div class="modal-body p-0">
        
        <div class="text-center p-5" *ngIf="isLoadingNotes">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3 text-muted">Fetching notes...</p>
        </div>

        <div class="text-center p-5" *ngIf="!isLoadingNotes && behalfNotes.length === 0">
          <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
          <p class="text-muted">No behalf enquiry notes found.</p>
        </div>

        <div class="list-group list-group-flush" *ngIf="!isLoadingNotes && behalfNotes.length > 0" style="max-height: 400px; overflow-y: auto;">
          <button type="button" class="list-group-item list-group-item-action p-3" *ngFor="let note of behalfNotes" (click)="selectBehalfNote(note.enquiryNotesId || note.id)">
            <div class="d-flex w-100 justify-content-between mb-1">
              <h6 class="mb-1 fw-bold">Note #{{ note.enquiryNotesId || note.id }}</h6>
              <small class="text-muted">{{ note.created_at || note.date | date:'short' }}</small>
            </div>
            <p class="mb-1 text-truncate" style="max-width: 90%;">{{ note.text || 'No text provided' }}</p>
            <div class="d-flex gap-2 mt-2">
              <span class="badge bg-light text-dark border" *ngIf="note.veh_no"><i class="fas fa-car me-1"></i>{{ note.veh_no }}</span>
              <span class="badge bg-light text-dark border" *ngIf="note.voice_url"><i class="fas fa-microphone-alt text-danger me-1"></i>Voice</span>
              <span class="badge bg-light text-dark border" *ngIf="note.images && note.images.length > 0"><i class="fas fa-images text-success me-1"></i>{{ note.images.length }} Images</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
